var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    [
      _c("q-icon", {
        staticClass: "ml-1",
        attrs: { name: "edit", size: "16px", color: "primary" }
      }),
      _c(
        "q-popup-edit",
        {
          staticClass: "contact-status-updated-at-date-picker",
          attrs: { buttons: "", persistent: true },
          on: { save: _vm.formatAndEmitDates },
          model: {
            value: _vm.payload,
            callback: function($$v) {
              _vm.payload = $$v
            },
            expression: "payload"
          }
        },
        [
          _vm.agent.contact_status_updated_at
            ? _c(
                "div",
                { staticClass: "bg-grey-3 p-3" },
                [
                  _vm._v("\n      Current date:\n      "),
                  _c("SdDatetime", {
                    staticClass: "d-block",
                    attrs: {
                      value: _vm.agent.contact_status_updated_at,
                      format: "MM/DD/YY"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _c(
            "div",
            [
              _c("q-datetime", {
                attrs: {
                  "float-label": "Day",
                  minimal: "",
                  "default-view": "day",
                  "today-btn": "",
                  "clear-value": null,
                  type: "date",
                  format: "MM/DD/YY",
                  "format-model": "string"
                },
                model: {
                  value: _vm.payload.contact_status_updated_at,
                  callback: function($$v) {
                    _vm.$set(_vm.payload, "contact_status_updated_at", $$v)
                  },
                  expression: "payload.contact_status_updated_at"
                }
              })
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }